import { Icon, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = {
	variant: "recording" | "completed";
	label: string;
	dotSize?: number;
};

const StatusHeader = ({ variant, label, dotSize = 8 }: Props) => {
	const theme = useAppTheme();
	return (
		<Box
			flexDirection="row"
			alignItems="center"
			gap={6}
			flexShrink={1}
			minWidth={0}
		>
			{variant === "recording" ? (
				<Box
					width={dotSize}
					height={dotSize}
					borderRadius={dotSize / 2}
					backgroundColor={theme.palette.error.main}
				/>
			) : (
				<Icon
					source="check-circle"
					size={20}
					color={theme.palette.success.main}
				/>
			)}
			<Text
				variant="titleSmall"
				style={{
					color: theme.colors.primary,
					fontWeight: "500",
					flexShrink: 1,
				}}
				numberOfLines={1}
			>
				{label}
			</Text>
		</Box>
	);
};

export default StatusHeader;
